import { httpClient } from '../http/httpClient'

export const uploadAttachment = async (
  id: string,
  documentoId: string,
  file: File,
) => {
  const formData = new FormData()
  formData.append('documentoId', documentoId)
  formData.append('file', file)

  try {
    const { data } = await httpClient.patch<{ data: string }>(
      `/transaction/${id}/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return data.data
  } catch (error: any) {
    throw error?.response?.data || error
  }
}
